import { useEffect, useState } from 'react';
import { loadRecurly, RecurlyWrapper, type IFieldState } from '@fff-web/fff-payments';
import { LoadingSpinner } from '@fff-web/fff-ui-shared';
import GiftCardPayForm from './GiftCardPayForm';
import '@fff-web/fff-payments/src/lib/assets/recurly.css';
import type { TokenPayload } from '@recurly/recurly-js';

type RecurlyGiftCardPayFormProps = {
  onSubmit: () => void;
  isDisabled: boolean;
  payFieldsState: {
    fields: Record<string, IFieldState>;
    hasErrors: boolean;
    onResponse: (err: Error, token: TokenPayload) => void;
  };
};

const RecurlyGiftCardPayForm = ({
  onSubmit = () => null,
  isDisabled = false,
  payFieldsState,
}: RecurlyGiftCardPayFormProps) => {
  const [isRecurlyLoaded, setIsRecurlyLoaded] = useState(false);

  useEffect(() => {
    loadRecurly().then(() => {
      setIsRecurlyLoaded(true);
    });
  }, []);

  return isRecurlyLoaded ? (
    <RecurlyWrapper>
      <GiftCardPayForm
        onSubmit={onSubmit}
        isDisabled={isDisabled}
        payFieldsState={payFieldsState}
      />
    </RecurlyWrapper>
  ) : (
    <LoadingSpinner />
  );
};

export default RecurlyGiftCardPayForm;
